import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';

import { Modal } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import { InputGroup } from 'react-bootstrap';
import ErrorAlert from '../../Alerts/ErrorAlert';
import { Badge } from 'react-bootstrap';

import { ListGroup } from 'react-bootstrap';
import { GroupsFechtAPI } from '../../../api/Groups';
import { Container } from 'react-bootstrap';
import { Row } from 'react-bootstrap';
import { Col } from 'react-bootstrap';

import add from '../../img/icons/add-product.png'

function ModalGroupsSelect({ productsBranchoffice, addGroups }) {
    const [showModal, setShowModal] = useState(false)
    const [groups, setGroups] = useState([])
    const [groupSelect, setGroupSelect] = useState("")
    const [searchedProducts, setSearchedProducts] = useState("")
    const [searchTerm, setSearchTerm] = useState('');
    const [groupsSelectList, setGroupsSelectList] = useState([])
    const [statusRequest, setStatusRequest] = useState(false);
    const [deleteMode, setDeleteMode] = useState(false)

    let token = localStorage.getItem("x-access-token")

    let user = localStorage.getItem('user');

    //Filter the products by the term searched 
    const filteredProducts = useMemo(() => {
        if (searchTerm === '') {
            return groups
        }
        return searchedProducts.filter(group => {
            const nameMatch = group.name.toLowerCase().includes(searchTerm.toLocaleLowerCase());
            const descriptionMatch = group.description.toLowerCase().includes(searchTerm.toLowerCase());
            return nameMatch || descriptionMatch;
        })
    }, [searchTerm, groups]);


    const handlerChecked = (e, group) => {
        if (e.target.checked == true) {
            if (groupsSelectList.length > 29) {
                ErrorAlert('', 'Superaste la cantidad q', 'warning')
                e.target.checked = false
            } else {
                setGroupsSelectList([...groupsSelectList, group]);
            }
        } else {
            let filtrado = groupsSelectList.filter(data => data.group_id != group.group_id)
            setGroupsSelectList(filtrado)
        }
    }

    const saveArrayGroups = () => {
        console.log(groupsSelectList)
        if (groupsSelectList.length > 30) {
            ErrorAlert('', 'Solo puedes agregar 30 productos a la ves', 'warning')
        } else {
            groupsSelectList.forEach((group, id, index) => {
                try {
                    addGroups(group)
                } catch (err) {
                    ErrorAlert('', 'Uno de los productos ya estaba asignado', 'warning')
                }
            });
            setGroupsSelectList([]);
            setSearchTerm('')
            setShowModal(false);
        }
    }

    const hadleselect = () => {
        setShowModal(true)
        //setDeleteMode(true)
        setGroups(productsBranchoffice)
        setSearchedProducts(productsBranchoffice)
    }

    return (
        <>


            <button className={'btn-add-product-list  rounded-4  pulse mt-4 py-4 w-100'}
                type='button' onClick={() => hadleselect()}
            >
                {/**Check user permition to create products */}
                <div className='d-flex justify-content-center '>
                    <img src={add} alt="Add" />
                </div>

                <div className="text-center ">
                    <span className='fw-bold'>Seleccionar productos</span>
                </div>
            </button>

            <Modal
                show={showModal}
                onHide={() => (setShowModal(false))}
                size='large'
                fullscreen
                centered>
                <Modal.Header className='text-center'>
                    <h3><i className="uil uil-file-plus-alt"></i>Selecion de productos </h3>
                </Modal.Header>
                <Modal.Body>

                    <Container>
                        <Row>
                            <Col sm="12 m-3">
                                <h3 className='text-center m-3'>Seleccione los productos</h3>
                                <p className='text-center '>Maximo 30 productos</p>
                                <div className="d-flex justify-centent-center align-items-center ">
                                    <form className="row g-3 align-content-center align-items-center">
                                        <div className="col-auto ">
                                            <span className='mb-0 text-secondary fw-bold' >Buscar</span>
                                        </div>
                                        <div className="col-auto">
                                            <input
                                                spellcheck="false"
                                                className="form-control"
                                                type="text"
                                                step="any"
                                                placeholder="Ingrese producto"
                                                onChange={e => setSearchTerm(e.target.value)}

                                            />
                                        </div>
                                    </form>
                                </div>

                                <div className="m-2 ">
                                    <span className='mb-0 text-secondary fw-bold' >Productos seleccionados: {groupsSelectList.length}</span>
                                </div>
                            </Col>
                            {filteredProducts.map(group => (
                                <>

                                    {group.group_type ? <>
                                        {group.group_type == "limited" ? <>
                                            <Col sm="4">
                                                <ListGroup as="ol" className='m-2' >
                                                    <ListGroup.Item
                                                        as="li"
                                                        className="d-flex justify-content-between align-items-start" >

                                                        {/*<img
                                                className='imgitemsList m-1'
                                                src={group.img}
                                                alt={groups.name}
                                            />*/}
                                                        <div className="ms-2 me-auto d-inline-block text-truncate">
                                                            <div className="fw-bold">{group.name ? group.name : group.group_name}</div>
                                                            <div className="">Cantidad: <b>{group.quantity}</b></div>

                                                        </div>
                                                        <div>
                                                            <InputGroup className="">
                                                                <InputGroup.Checkbox aria-label="Checkbox for following text input" onChange={(e) => handlerChecked(e, group)} />
                                                            </InputGroup>
                                                        </div>
                                                    </ListGroup.Item>
                                                </ListGroup>
                                            </Col>
                                        </> : <>
                                        </>}</> : <>
                                        <Col sm="4">
                                            <ListGroup as="ol" className='m-2' >
                                                <ListGroup.Item
                                                    as="li"
                                                    className="d-flex justify-content-between align-items-start" >

                                                    {/*<img
                                                className='imgitemsList m-1'
                                                src={group.img}
                                                alt={groups.name}
                                            />*/}
                                                    <div className="ms-2 me-auto d-inline-block text-truncate">
                                                        <div className="fw-bold">{group.name ? group.name : group.group_name}</div>
                                                        <div className="">Cantidad: <b>{group.quantity}</b></div>

                                                    </div>
                                                    <div>
                                                        <InputGroup className="">
                                                            <InputGroup.Checkbox aria-label="Checkbox for following text input" onChange={(e) => handlerChecked(e, group)} />
                                                        </InputGroup>
                                                    </div>
                                                </ListGroup.Item>
                                            </ListGroup>
                                        </Col>
                                    </>}
                                </>
                            ))}
                        </Row>
                    </Container>
                </Modal.Body>
                <Modal.Footer>

                    <div className='d-flex justify-content-between'>
                        <Button className='m-2' size="sm" onClick={() => (setShowModal(false), setGroupsSelectList([]), setDeleteMode(false), setSearchTerm(''))}>Cerrar</Button>

                        {deleteMode == true ?
                            <Button className='m-2' size="sm" variant="danger" type="button" onClick={() => saveArrayGroups()}>
                                Eliminar
                            </Button> :
                            <Button className='m-2' size="sm" variant="success" type="button" onClick={() => saveArrayGroups()}>
                                Guardar
                            </Button>}
                    </div>
                </Modal.Footer>
            </Modal >

        </>
    )
}

export default ModalGroupsSelect